import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, first } from 'rxjs/operators';

import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class FacilityService {

  private facility = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) {
  }

  public updateFacility = (id: string) => {
    var path = `/facility/${id}`
    return this.cms.request('GET', path).pipe(
      first(),
      map(body => {
        this.facility.next(body.data)
        return body.data
      })
    )
  }

  public getFacility = (): Observable<any> => {
    return this.facility.asObservable()
  }
}
